import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';
import { Icon, type IconName } from './icon';
import { cn } from '@/lib/cn';

export type ChipProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  active?: boolean;
  icon?: IconName;
  children?: ReactNode;
};

export function Chip({
  active = false, icon, className, type = 'button', children, ...rest
}: ChipProps): ReactElement {
  return (
    <button
      type={type}
      aria-pressed={active}
      className={cn(
        'inline-flex items-center gap-1.5 h-7 px-2.5 rounded-[var(--r-sm)] text-[12px] font-medium whitespace-nowrap transition-colors',
        active
          ? 'bg-[var(--ink)] text-[var(--bg-surface)]'
          : 'bg-[var(--bg-surface)] border border-[var(--rule)] text-[var(--ink-2)] hover:border-[var(--rule-strong)]',
        className,
      )}
      {...rest}
    >
      {icon && <Icon name={icon} size={11} />}
      {children}
    </button>
  );
}
